const initAbra = () => {
  if (!document.body) {
    setTimeout(initAbra, 50);
    return;
  }

(() => {
  const waitForAbra = setInterval(() => {
    if (window.Abra) {
      clearInterval(waitForAbra);
      init();
    }
  }, 100);

  function init() {
    let isRendering = false;
    let renderQueued = false;
    const processedCards = new WeakSet();
    let mutationDebounceTimer = null;
    let observer = null;

    const applyHandle = (card) => {
      if (processedCards.has(card)) return false;
      
      const link = card.querySelector('a[href*="/products/"]');
      if (link) {
        const match = link.href.match(/\/products\/([^?]+)/);
        if (match) {
          const handle = match[1];
          card.setAttribute('data-product-handle', handle);
          const priceContainer = card.querySelector('.rebuy-product-price');
          if (priceContainer) {
            priceContainer.setAttribute('data-product-handle', handle);
          }
          const priceEl = card.querySelector('.rebuy-money');
          if (priceEl) {
            priceEl.setAttribute('data-product-handle', handle);
          }
          processedCards.add(card);
          return true;
        }
      }
      return false;
    };

    const safeRender = () => {
      if (isRendering) {
        renderQueued = true;
        return;
      }
      
      isRendering = true;
      if (observer) observer.disconnect();
      
      try {
        window.Abra.render();
      } finally {
        setTimeout(() => {
          isRendering = false;
          if (observer) observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
          if (renderQueued) {
            renderQueued = false;
            safeRender();
          }
        }, 50);
      }
    };

    const processCards = () => {
      const cards = document.querySelectorAll('.rebuy-product-block');
      let hasChanges = false;
      cards.forEach(card => {
        if (applyHandle(card)) hasChanges = true;
      });
      if (hasChanges) {
        safeRender();
      }
    };

    const scheduleProcess = (delays) => {
      delays.forEach(delay => setTimeout(processCards, delay));
    };

    setTimeout(processCards, 2000);

    document.addEventListener('click', (e) => {
      if (e.target.closest('.rebuy-button, button')?.textContent.includes('ADD TO BAG')) {
        scheduleProcess([100, 500, 1500, 3000]);
      }
    }, true);

    observer = new MutationObserver((mutations) => {
      if (isRendering) return;
      
      clearTimeout(mutationDebounceTimer);
      mutationDebounceTimer = setTimeout(() => {
        let newProductBlocks = [];
        let shouldProcess = false;
        
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                if (node.matches?.('.rebuy-product-block')) {
                  newProductBlocks.push(node);
                } else if (node.querySelector?.('.rebuy-product-block')) {
                  node.querySelectorAll('.rebuy-product-block').forEach(card => newProductBlocks.push(card));
                }
                if (node.matches?.('.rebuy-cart__flyout, [class*="rebuy-cart"]') || node.querySelector?.('.rebuy-cart__flyout, [class*="rebuy-cart"]')) {
                  shouldProcess = true;
                }
              }
            });
          }
          if (mutation.type === 'attributes' && mutation.target.matches?.('.rebuy-cart__flyout, [class*="rebuy-cart"]')) {
            shouldProcess = true;
          }
        });
        
        if (newProductBlocks.length > 0) {
          let hasChanges = false;
          newProductBlocks.forEach(card => {
            if (applyHandle(card)) hasChanges = true;
          });
          if (hasChanges) {
            setTimeout(() => {
              newProductBlocks.forEach(applyHandle);
              safeRender();
            }, 500);
          }
        }
        
        if (shouldProcess) {
          scheduleProcess([200, 500]);
        }
      }, 100);
    });
    
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });

    let cartChangeDebounce = null;
    document.addEventListener('rebuy:cart.change', () => {
      clearTimeout(cartChangeDebounce);
      cartChangeDebounce = setTimeout(() => scheduleProcess([200, 500]), 100);
    });
  }
})();
  
(() => {
  const processedCards = new WeakSet();
  let isRendering = false;
  let renderQueued = false;
  let debounceTimer = null;

  const applyHandle = (card) => {
    if (processedCards.has(card)) return false;
    
    const link = card.querySelector('a[href*="/products/"]');
    if (link) {
      const match = link.href.match(/\/products\/([^?]+)/);
      if (match) {
        const handle = match[1];
        card.setAttribute('data-product-handle', handle);
        const priceContainer = card.querySelector('.rebuy-product-price');
        if (priceContainer) {
          priceContainer.setAttribute('data-product-handle', handle);
        }
        const priceEl = card.querySelector('.rebuy-money');
        if (priceEl) {
          priceEl.setAttribute('data-product-handle', handle);
        }
        processedCards.add(card);
        return true;
      }
    }
    return false;
  };

  const safeRender = () => {
    if (!window.Abra) return;
    if (isRendering) {
      renderQueued = true;
      return;
    }
    
    isRendering = true;
    try {
      window.Abra.render();
    } finally {
      setTimeout(() => {
        isRendering = false;
        if (renderQueued) {
          renderQueued = false;
          safeRender();
        }
      }, 50);
    }
  };

  const processSearchCards = () => {
    const cards = document.querySelectorAll('.predictive-search__grid-item');
    let hasChanges = false;
    if (cards.length) {
      cards.forEach(card => {
        if (applyHandle(card)) hasChanges = true;
      });
      if (hasChanges) {
        safeRender();
      }
    }
  };

  processSearchCards();

  new MutationObserver((mutations) => {
    if (isRendering) return;
    
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      let hasChanges = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              if (node.matches?.('.predictive-search__grid-item')) {
                if (applyHandle(node)) hasChanges = true;
              }
              const cards = node.querySelectorAll?.('.predictive-search__grid-item');
              if (cards?.length) {
                cards.forEach(card => {
                  if (applyHandle(card)) hasChanges = true;
                });
              }
            }
          });
        }
      });
      
      if (hasChanges) {
        safeRender();
      }
    }, 100);
  }).observe(document.body, { childList: true, subtree: true });
})();
  
  (() => {
    let updateTimer = null;
    let isUpdating = false;
    
    const triggerCartUpdate = () => {
      if (isUpdating) return;
      
      clearTimeout(updateTimer);
      updateTimer = setTimeout(() => {
        isUpdating = true;
        document.dispatchEvent(new CustomEvent('rebuy:cart.change', { detail: { cart: {} } }));
        setTimeout(() => { isUpdating = false; }, 1000);
      }, 800);
    };
    
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.rebuy-cart__flyout-item-quantity-widget-button, .rebuy-cart__flyout-item-remove');
      if (btn) {
        triggerCartUpdate();
      }
    });
  })();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAbra);
} else {
  initAbra();
}

(() => {
  let isProcessing = false;
  let debounceTimer = null;
  let observer = null;

  const addWrappers = () => {
    const skioRoot = document.querySelector('skio-plan-picker');
    if (!skioRoot?.shadowRoot) return false;
    
    const root = skioRoot.shadowRoot;
    let modified = false;
    
    const oneTimePrice = root.querySelector('.skio-plan-picker label[for^="one-time"] .skio-price');
    if (oneTimePrice && !oneTimePrice.parentElement.classList.contains('wrapper-onetime')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'wrapper-onetime anchor';
      wrapper.style.display = 'contents';
      
      oneTimePrice.parentNode.insertBefore(wrapper, oneTimePrice);
      wrapper.appendChild(oneTimePrice);
      modified = true;
    }
    
    const subscribePrice = root.querySelector('.skio-plan-picker label[for^="group-"] .skio-price');
    if (subscribePrice && !subscribePrice.parentElement.classList.contains('wrapper-subscribe')) {
      const wrapper = document.createElement('div');
      wrapper.className = 'wrapper-subscribe anchor';
      wrapper.style.display = 'contents';
      
      subscribePrice.parentNode.insertBefore(wrapper, subscribePrice);
      wrapper.appendChild(subscribePrice);
      modified = true;
    }
    
    return modified;
  };

  const safeAddWrappers = () => {
    if (isProcessing) return;
    
    isProcessing = true;
    if (observer) observer.disconnect();
    
    try {
      addWrappers();
    } finally {
      setTimeout(() => {
        isProcessing = false;
        if (observer) {
          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        }
      }, 100);
    }
  };
  
  const patchSkioUpdated = () => {
    const skioElement = document.querySelector('skio-plan-picker');
    if (!skioElement || skioElement.__wrappersPatched) return;
    
    const originalUpdated = skioElement.updated;
    if (originalUpdated) {
      skioElement.updated = function(changedProperties) {
        originalUpdated.call(this, changedProperties);
        setTimeout(safeAddWrappers, 50);
      };
      skioElement.__wrappersPatched = true;
    }
  };
  
  setTimeout(safeAddWrappers, 500);
  setTimeout(safeAddWrappers, 1000);
  setTimeout(safeAddWrappers, 2000);
  setTimeout(patchSkioUpdated, 100);
  setTimeout(patchSkioUpdated, 500);
  
  observer = new MutationObserver(() => {
    if (isProcessing) return;
    
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      safeAddWrappers();
      patchSkioUpdated();
    }, 150);
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  let variantChangeDebounce = null;
  document.addEventListener('variant:change', () => {
    clearTimeout(variantChangeDebounce);
    variantChangeDebounce = setTimeout(safeAddWrappers, 100);
  });
})();

(() => {
  let isRendering = false;
  let renderQueued = false;
  let debounceTimer = null;
  let observer = null;

  const initAbra = () => {
    if (!window.Abra) return;
    
    if (isRendering) {
      renderQueued = true;
      return;
    }
    
    isRendering = true;
    if (observer) observer.disconnect();
    
    try {
      window.Abra.useSellingPlanPriceOnProductBlock = true;
      window.Abra.render();
    } finally {
      setTimeout(() => {
        isRendering = false;
        if (observer) {
          const skioBlock = document.querySelector('[skio-plan-picker]');
          if (skioBlock) {
            observer.observe(skioBlock, {
              childList: true,
              subtree: true,
              attributes: true
            });
          }
        }
        if (renderQueued) {
          renderQueued = false;
          initAbra();
        }
      }, 100);
    }
  };

  const observeSkio = () => {
    const skioBlock = document.querySelector('[skio-plan-picker]');
    if (!skioBlock) return;

    observer = new MutationObserver(() => {
      if (isRendering) return;
      
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        initAbra();
      }, 150);
    });

    observer.observe(skioBlock, {
      childList: true,
      subtree: true,
      attributes: true
    });
    
    initAbra();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSkio);
  } else {
    observeSkio();
  }

  setTimeout(initAbra, 100);
  setTimeout(initAbra, 500);
  setTimeout(initAbra, 1000);
})();

(() => {
  const modals = new Map();
  let rendering = false;
  
  const apply = (m) => {
    const i = m.querySelector('input[data-single-option-selector]:checked');
    if (!i) return;
    const v = i.getAttribute('data-variant-id'), h = i.getAttribute('data-product-handle');
    if (!v) return;
    m.setAttribute('data-variant-id', v);
    ['.product__price__wrap', '[data-price-wrapper]', '[data-add-to-cart-text]'].forEach(s => 
      m.querySelectorAll(s).forEach(e => (e.setAttribute('data-variant-id', v), e.setAttribute('data-product-handle', h)))
    );
  };
  
  const safeRender = () => {
    if (rendering) return;
    rendering = true;
    window.Abra?.render();
    setTimeout(() => rendering = false, 600);
  };
  
  const setup = (m) => {
    apply(m);
    safeRender();
    let timeout;
    const h = (e) => {
      if (e.target.matches('input[data-single-option-selector]') && m.contains(e.target)) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          apply(m);
          setTimeout(safeRender, 500);
        }, 50);
      }
    };
    document.addEventListener('change', h);
    return () => {
      clearTimeout(timeout);
      document.removeEventListener('change', h);
    };
  };
  
  new MutationObserver(ms => ms.forEach(m => {
    if (m.attributeName === 'open' && m.target.matches('.product-quick-add')) {
      const t = m.target;
      t.hasAttribute('open') ? !modals.has(t) && modals.set(t, setup(t)) : 
        modals.has(t) && (modals.get(t)(), modals.delete(t));
    }
  })).observe(document.body, { attributes: true, attributeFilter: ['open'], subtree: true });
  
  setTimeout(() => document.querySelectorAll('.product-quick-add[open]').forEach(m => modals.set(m, setup(m))), 500);
})();